
/** DO NOT EDIT THIS FILE! */
import { Version } from '@angular/core';
import { Bundle } from './models';

export const VERSION = new Version('2.0.16');

export const BUNDLE: Bundle = {
  date: 1792487658262,
  commitSha: 'unknown',
  version: VERSION,
};
